export const openGraphConfig = <TextType = string>(
  url: string,
  title: TextType,
  description?: TextType,
  imageUrl?: string
) => {
  const config = {
    openGraph: {
      type: 'website',
      title,
      description,
      url,
      // eslint-disable-next-line @typescript-eslint/camelcase
      site_name: 'Codingal',
      images: [
        {
          url: imageUrl || 'https://fastly.codingal.com/images/meta-image.png',
          alt: 'Codingal',
        },
      ],
    },
    twitter: {
      handle: '@codingal',
      cardType: 'summary_large_image',
    },
    facebook: {
      appId: '373752980313511',
    },
  }
  return config
}

export const defaultSeo = {
  titleTemplate: '%s | Codingal',
  title: 'Online coding classes for kids',
  description:
    'Codingal is on a mission to provide coding education to every K-12 student. Kids start learning to code via online coding classes conducted by best teachers and using an engaging curriculum.',
  ...openGraphConfig(
    'https://www.codingal.com/',
    'Online coding classes for kids',
    'Codingal is on a mission to provide coding education to every K-12 student. Kids start learning to code via online coding classes conducted by best teachers and using an engaging curriculum.'
  ),
}

export const aiconnectSeo = (urlPath: string) => ({
  title:
    '【アイネットご入居様限定】世界標準のAI・プログラミングレッスン｜最大40%オフ｜Codingal',
  description:
    '【アイネットご入居様だけの限定特典！】無料体験レッスン3回＆授業料最大40%オフ。70カ国で選ばれる国際認定カリキュラムで、お子様の未来に必要なプログラミングスキルを楽しく習得。現役のプログラミング講師が、小学生から高校生まで個別指導します。（日本語・英語選択可能）',
  ...openGraphConfig(
    `https://www.codingal.com/${urlPath}/`,
    '【アイネットご入居様限定】世界標準のAI・プログラミングレッスン｜最大40%オフ｜Codingal',
    '【アイネットご入居様だけの限定特典！】無料体験レッスン3回＆授業料最大40%オフ。70カ国で選ばれる国際認定カリキュラムで、お子様の未来に必要なプログラミングスキルを楽しく習得。現役のプログラミング講師が、小学生から高校生まで個別指導します。（日本語・英語選択可能）',
    `${process.env.NEXT_PUBLIC_STATIC_URL}/images/aiconnect/meta-image.png`
  ),
})
export const geoLongLandingPageSeo = (urlPath: string) => ({
  title:
    'Try a free coding class for your child | Codingal is the #1 Coding Platform for kids',
  description:
    'Let your child learn the fundamentals of coding. They can build animations, websites and mobile app with expert computer science teachers.',
  ...openGraphConfig(
    `https://www.codingal.com/lp/${urlPath}/`,
    'Try a free coding class for your child | Codingal is the #1 Coding Platform for kids',
    'Let your child learn the fundamentals of coding. They can build animations, websites and mobile app with expert computer science teachers.',
    `${process.env.NEXT_PUBLIC_STATIC_URL}/images/book-trial-class/meta-image.png`
  ),
})

export const codingWorkshopSeo = {
  title:
    'Free coding workshop for kids and teens | Codingal is the #1 Coding Platform for kids',
  description:
    'Let your child learn the fundamentals of coding. They can build animations, websites and mobile app with expert computer science teachers.',
  ...openGraphConfig(
    `https://www.codingal.com/lp/coding-workshop/`,
    'Free coding workshop for kids and teens | Codingal is the #1 Coding Platform for kids',
    'Let your child learn the fundamentals of coding. They can build animations, websites and mobile app with expert computer science teachers.',
    `${process.env.NEXT_PUBLIC_STATIC_URL}/images/book-trial-class/meta-image.png`
  ),
}

export const codingForKidsGlobalSeo = {
  title: 'Free Online Coding for Kids',
  description:
    'Free coding for kids - 8 free resources to start: competitions, quizzes, masterclasses, worksheets, guides and more. Explore free coding activities for ages 5-17.',
  ...openGraphConfig(
    'https://www.codingal.com/coding-for-kids/',
    'Free Online Coding for Kids | Codingal',
    'Free coding for kids - 8 free resources to start: competitions, quizzes, masterclasses, worksheets, guides and more. Explore free coding activities for ages 5-17.',
    `${process.env.NEXT_PUBLIC_STATIC_URL}/images/coding-for-kids/meta-image.png`
  ),
}

export const NOINDEX_PAGE_GLOBS = [
  '/**/buy-course',
  '/**/checkout',
  '/**/thank-you',
  '/**/lp/**',
  '/exclusive-coding-package/**',
  '/payment-partners/**',
  '/@**/**', // Noindex all user profiles pages
  '/camp/registration-success**', // coding camp - Registration success page (post-payment)
  '/aiconnect/', // aiconnect noindexed
  '/embed/**', // Noindex all embed pages
  '/quizzes/**/arena', // Noindex quiz arena pages
]
